import AppLayout from '../Layout/AppLayout';
import ContenuStat from '../Components/Statistiques/ContenuStat';

const Stat = () => {
    return (
        <AppLayout>
            <ContenuStat />
        </AppLayout>
    );
};

export default Stat;
